/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-20 15:30:48
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-21 14:27:21
 * @FilePath: /wemeet-admin-new/src/api/recruitment/job/category.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 查询岗位分类列表
export function getCategoryList(data) {
  return request({
    url: '/user/admin/enterprise/job/category/list',
    method: 'POST',
    data,
  })
}

// 查询岗位分类树
export function getCategoryTree() {
  return request({
    url: '/user/admin/enterprise/job/category/get',
    method: 'GET',
  })
}

// 新增岗位分类
export function addCategory(data) {
  return request({
    url: '/user/admin/enterprise/job/category/add',
    method: 'POST',
    data,
  })
}

// 更新岗位分类
export function updateCategory(data) {
  return request({
    url: '/user/admin/enterprise/job/category/update',
    method: 'POST',
    data,
  })
}
